import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { User } from '../models/auth.model';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private authService = inject(AuthService);

  private user?: User;

  constructor() {
    this.authService.user$.subscribe((user) => (this.user = user));
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.checkAuth(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
    return this.checkAuth(route);
  }

  checkAuth(route: ActivatedRouteSnapshot) {
    if (this.authService.isAuthenticated()) {
      if (route?.data['accessRole'] != undefined) {
        const result = this.user?.getAccessibleModules().find((a) => a.role == route.data['accessRole']) != undefined;
        if (!result) {
          this.authService.signOut(true);
        }
        return result;
      } else {
        return true;
      }
    }
    this.authService.signOut();
    return false;
  }
}
